import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { ArrowBackIconComponent } from "assets/icons";
import styles from "./styles.module.scss";
import routes from "routes";

function BackButton() {
  const navigate = useNavigate();

  return (
    <span
      onClick={() => navigate(routes.convsList)}
      className={clsx(["no-margin", styles.back_icon])}
    >
      <ArrowBackIconComponent />
    </span>
  );
}

export default BackButton;
